import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { Container, useThemedValueSwitch } from '@tq/ui-components';

import { annualDfiReportYearState } from 'store';
import { CompleteDfiReport, DraftDfiReport } from '../';
import { useDfiAnnualReport } from 'api';

export const AnnualDfiReport: React.FC = () => {
  const { t } = useTranslation('annual_dfi_report');

  const reportYear = useRecoilValue(annualDfiReportYearState);

  const { data: report } = useDfiAnnualReport();

  const { isTQ } = useThemedValueSwitch();

  const organisationNameHeading = report?.parentOrganisationName
    ? ` ${t('for', 'for')} ${report?.parentOrganisationName}`
    : '';

  const fyStartDay = `${t('fy_start_day', '1st April')} ${reportYear}`;
  const fyEndDay = `${t('fy_end_day', '- 31st March')} ${reportYear + 1}`;
  const tqEnAnnualReportLabel = `${t('tqen_annual_report', 'Annual Report')}`;
  const AnnualDfiReportLabel = `${t('annual_dfi_report', 'Annual DfI Report')}`;

  const heading = `${
    isTQ ? tqEnAnnualReportLabel : AnnualDfiReportLabel
  } ${fyStartDay} ${fyEndDay} ${organisationNameHeading}`;

  return (
    <Container px={{ base: 0, lg: 4, xl: 0 }} mb={6}>
      {report &&
        (report.dateCompleted ? (
          <CompleteDfiReport heading={heading} report={report} />
        ) : (
          <DraftDfiReport heading={heading} report={report} />
        ))}
    </Container>
  );
};
